export default {
  edit: { id: 'edit' },
  title: { id: 'title' },
  dateUpdated: { id: 'date_updated' },
  saveInfo: { id: 'save_info' },
  logbookEventTranslation: { id: 'logbook_event_translation' },
  logbookEventList: { id: 'logbook_event_list' },
  options: { id: 'options' },
  constantValue: { id: 'constant_value' },
  unit: { id: 'unit' },
  fileTitle: { id: 'file_title' },
  commentTitle: { id: 'comment_title' },
}
